import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setBreadCrumb } from "../../../../store/userSlice";
import MobilizationList from "./MobilizationList";

export default function Mobilization() {
  const title = [
    {
      label: "MOBILIZATION > ARRIVED-IDLE MOBILIZATION",
      link: "/dashboard/mobilization",
    },
  ];
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  
  useEffect(() => {
    dispatch(setBreadCrumb(title));
  }, []);

  // updateData function is no longer needed since MobilizationList handles its own data fetching
  const updateData = () => {
    // This will be handled by the MobilizationList component's apiCall function
  };

  return (
    <div className={`p-2 `}>
      <MobilizationList
        list={{}} // Empty object since we're not using Redux data anymore
        titles={[
          " S.NO.",
          "POINT OF HIRE",
          "EMPLOYEE ID",
          "EMPLOYEE NAME",
          "NATIONALITY",
          "ACTUAL PROFESSION",
          "VISA PROFESSION",
          "CLIENT",
          "PROJECT",
          "VISA PROVIDER",
          "BORDER NUMBER",
          "IQAMA NUMBER",
          "ARRIVAL DATE",
          "AGING (in days)",
          "STATUS",
          "CHANGE CLIENT, SALARY & OTHERS",
          "SELECT",
        ]}
        token={token}
        updateData={updateData}
      />
    </div>
  );
}
